// Immediate-loaded route components
// import pmAppLoaderComponent from '../components/app/app-loader.vue';
// import pmAccessDeniedComponent from '@planmaster/common/src/components/app/app-access-denied.vue';
// import loadAnimationModule from '../modules/animations.js';

import PmDashboardComponent from "../components/dashboard/dashboard";
import PmPlanCalculator from "../components/calculator/plan-calculator";
// import PmPlanSimple from "../components/plan-simple/plan-simple";
const PmPlanSimple = () => import(/* webpackChunkName: "chunk-plan" */ "../components/plan-simple/plan-simple");
import PmAnimationListComponent from "../components/animations/animations";
// import PmAnimationComponent from "../components/animations/animation.vue";
import PmAppSettingsComponent from "../components/settings/settings";
import PmAppAdvancedSettingsComponent from "../components/settings/advanced-settings";
import PmAppSettingsWizardComponent from "../components/settings/settings-wizard";
import PmPriceListComponent from "../components/settings/pricelist";
// import PmProtocolSettingsComponent from "../components/settings/settings-protocols";
import PmHistoryComponent from "../components/history/history";
// import PmTestComponent from "../components/settings/test";
import PmSupportComponent from "../components/support/support";
// import PmTermsAndConditionsComponent from "../components/support/terms-and-conditions";
// import PmPrivacyPolicy from "../components/support/privacy-policy";
// import PmSubscriptions from "../components/subscriptions/subscriptions";
import PmFeedbackComponent from "../components/support/feedback";
import PmAddons from "../components/addons/addons";
import PmBrightplansComponent from "../components/support/bright-plans";
import PmReviewComponent from "../components/support/review";

const PmTermsAndConditionsComponent = () => import(/* webpackChunkName: "chunk-support" */ "../components/support/terms-and-conditions");
const PmPrivacyPolicy = () => import(/* webpackChunkName: "chunk-support" */ "../components/support/privacy-policy");
import PmGallery from "../components/gallery/gallery";
import PmGalleryBeforeAfter from "../components/gallery/before-after";
import PmGalleryFavourites from "../components/gallery/favourites";
import PmGalleryItem from "../components/gallery/group-item-page";
import PmMessages from "../components/messages/messages";

import PmFaq from "../components/faq/faq.vue";
import PmTutorials from "../components/faq/tutorials.vue";

/** @type {Map<string, string>} */
const packageResolverList = new Map([
    ["null", "/plan"],
    ["com.denticalc.calculationtool", "/plan"],
    ["com.denticalc.calculator", "/calculator"],
    ["com.denticalc.photos", "/gallery"],
    ["com.denticalc.pro", "/plan"],
    ["com.denticalc.videos", "/animations"],
    ["com.denticalc.4in1", "/"],
]);

/**
 * This works while store is initiated before the router!
 * Hide app navigation drawer.
 *
 * @return {void}
 */
const hideAppDrawer = () => {
    try {
        app.$store.state.app.drawer = false;
    } catch(error) {
        captureException(error);
    }
};

// Routes, in alphabetical order
const routes = [
    {
        name: "not-found",
        path: "*",
        beforeEnter: function(to, from, next) {
            // eslint-disable-next-line no-undef
            router.push("/plan").catch(() => {});
        },
    },
    {
        name: "home",
        path: "/",
        alias: "/home",
        component: PmDashboardComponent,
        async beforeEnter(_, __, next) {
            /** @type {{ packageName: string }} */
            const {packageName} = window;

            /** @type {string?} */
            const route = packageResolverList.get(String(packageName));

            // Go forward, if route not found.
            if (!route || route === "/") return next();

            try {
                // Go to given route name.
                await router.push(route).catch(() => {});
            } catch(error) {
                captureException(error);
                // Do not care about error, but disable drawer on ui.
                hideAppDrawer();
            }
        },
    },
    /* {
        name: "test",
        path: "/test",
        component: PmTestComponent,
    },*/
    {
        name: "calculator",
        path: "/calculator",
        component: PmPlanCalculator,
        beforeEnter: function(to, from, next) {
            if (!window.packageName) router.push("/plan").catch(() => {});
            else if (window.packageName !== "com.denticalc.calculator" && window.packageName !== "com.denticalc.4in1") router.push("/").catch(() => {});
            else next();
        },
    },
    {
        name: "plan",
        path: "/plan",
        component: PmPlanSimple,
        beforeEnter(_, __, next) {
            if (!window.packageName ||
                window.packageName !== "com.denticalc.calculationtool" ||
                window.packageName !== "com.denticalc.pro"
            ) return next();

            router.push("/").catch(() => {});
        },
    },
    {
        name: "gallery",
        path: "/gallery",
        component: PmGallery,
    },
    {
        name: "gallery-before-after",
        path: "/gallery-before-after",
        component: PmGalleryBeforeAfter,
    },
    {
        name: "gallery-favourites",
        path: "/gallery-favourites",
        component: PmGalleryFavourites,
    },
    {
        name: "gallery-page",
        path: "/gallery/:id",
        component: PmGalleryItem,
    },
    {
        name: "history",
        path: "/history",
        component: PmHistoryComponent,
    },
    {
        name: "settings",
        path: "/settings",
        component: PmAppSettingsComponent,
    },
    {
        name: "advanced-settings",
        path: "/advanced-settings",
        component: PmAppAdvancedSettingsComponent,
    },
    {
        name: "settings-wizard",
        path: "/settings-wizard",
        component: PmAppSettingsWizardComponent,
    },
    {
        name: "pricelist",
        path: "/pricelist",
        component: PmPriceListComponent,
    },
    /* {
        name: "protocols",
        path: "/protocols",
        component: PmProtocolSettingsComponent,
    },*/
    {
        name: "animations",
        path: "/animations",
        component: PmAnimationListComponent,
    },
    {
        name: "animation-favourites",
        path: "/animations/favourites",
        component: PmAnimationListComponent,
    },
    /* {
        name: "animation",
        path: "/animation/:id",
        component: PmAnimationComponent,
    },*/
    {
        name: "support",
        path: "/support",
        component: PmSupportComponent,
    },
    {
        name: "brightplans",
        path: "/brightplans",
        component: PmBrightplansComponent,
    },
    {
        name: "review",
        path: "/review",
        component: PmReviewComponent,
    },
    {
        name: "feedback",
        path: "/feedback",
        component: PmFeedbackComponent,
    },
    {
        name: "terms-and-conditions",
        path: "/terms-and-conditions",
        component: PmTermsAndConditionsComponent,
    },
    {
        name: "privacy-policy",
        path: "/privacy-policy",
        component: PmPrivacyPolicy,
    },
    {
        name: "faq",
        path: "/faq",
        component: PmFaq,
    },
    {
        name: "tutorials",
        path: "/tutorials",
        component: PmTutorials,
    },
    {
        name: "messages",
        path: "/messages",
        component: PmMessages,
    },
];

// if (typeof FlutterSubscribeService !== "undefined") {
// routes.push({
//     name: "subscriptions",
//     path: "/subscriptions",
//     component: PmSubscriptions,
// });
// }

routes.push({
    name: "addons",
    path: "/addons",
    component: PmAddons,
});

export default routes;
